/* ============================================================================
   MAMEIDO Etappe B - Back-in-Stock (Klaviyo)
   Datei: assets/mameido-bis.js.liquid
   ----------------------------------------------------------------------------
   SCHRITT 3 (dieser Stand): Echter Klaviyo-Client-API-Call beim Absenden.
   Der Klick auf den bestehenden Benachrichtigen-Button ([data-mameido-notify],
   aus Etappe A) oeffnet das mameido-Modal; Schliessen per X, Escape und Klick
   auf das Overlay. Beim Absenden wird die E-Mail validiert und -- bei gueltiger
   Eingabe -- eine Back-in-Stock-Subscription an Klaviyo gesendet. Erfolg/Fehler
   erscheinen im Feedback-Bereich (.mameido-bis-feedback, data-state).

   KLAVIYO-CLIENT-ENDPOINT (offizieller BIS-Guide, verifiziert):
     POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=<PUBLIC_KEY>
     Header: content-type: application/json, revision: 2024-06-15
     NUR oeffentlicher Key (company_id) -- niemals ein privater Key clientseitig.
     Variant-ID-Format zwingend: $shopify:::$default:::<SHOPIFY_VARIANT_ID>
     Erfolg = HTTP 202 mit LEEREM Body -> NICHT .json() erzwingen, nur Status
     auswerten (sonst "Unexpected end of JSON input").
   Der BIS-Call allein zeichnet KEINE Marketing-Consent auf (per Klaviyo-Doku
   fuer E-Mail nicht noetig). Die optionale Newsletter-Kopplung (Haekchen ->
   Liste) ist bewusst eine SPAETERE Stufe 2 und hier noch OHNE Funktion.

   TEXT-DYNAMIK:
   - Headline generisch, mit festem Zeilenumbruch nach "verfuegbar".
   - Body nennt die konkrete Variante ("... sobald <Farbe> in <Groesse> wieder
     auf Lager ist.", beide fett) oder generischen Fallback. Headline + Body
     werden bei JEDEM Oeffnen frisch aus der aktuellen Variante gesetzt.

   ARCHITEKTUR (Robustheit):
   - Eigene, kleine Datei statt Eingriff in die grosse mameido.js.liquid.
   - Eigenes Overlay im mameido-Look (kein Theme-Modal). CSS liegt live in
     mameido.css.liquid (.mameido-bis-*). Dieses JS erzeugt genau diese Klassen.
   - Variant-ID-Quelle: window.mameido.variant.id (von der grossen mameido.js
     bei jedem 'variant:change' gepflegt; liefert auch fuer ausverkaufte
     Varianten die ID, anders als das native <select name="id">).
   - Farbe/Groesse: window.mameido.variant.option1 (Farbe) / .option2 (Groesse).
   - Alles gescopt/delegiert -> Quick-View-sicher.

   Der oeffentliche Klaviyo-Company-Key (Site-ID) wird serverseitig via Liquid
   gesetzt, damit er nicht hart im Code steht:
   ============================================================================ */

var MAMEIDO_BIS_COMPANY_ID = "UZQtCC";

(function () {
  'use strict';

  // Verhindert doppelte Initialisierung, falls die Datei mehrfach eingebunden wird.
  if (window.__mameidoBisInit) return;
  window.__mameidoBisInit = true;

  // --- Konstanten fuer den Klaviyo-Client-Call ---
  var BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var BIS_REVISION = '2024-06-15';
  // Variant-ID-Praefix fuer Shopify-Kataloge in Klaviyo.
  var BIS_VARIANT_PREFIX = '$shopify:::$default:::';

  /* --- Konstanten fuer die OPTIONALE Newsletter-Kopplung (Stufe 2) ---
     Nur aktiv, wenn der Nutzer das Haekchen setzt. Traegt die E-Mail in die
     Liste "Homepage_10%" (Double Opt-in) ein -> Klaviyo verschickt selbst die
     Bestaetigungsmail; erst nach deren Bestaetigung wird der 10%-Code-Flow
     ausgeloest. Voellig unabhaengig vom BIS-Call: schlaegt dieser Call fehl,
     bleibt die BIS-Erfolgsmeldung unberuehrt (Fehler nur in der Konsole).
     Offizieller Client-Endpoint (verifiziert):
       POST https://a.klaviyo.com/client/subscriptions/?company_id=<PUBLIC_KEY>
       Header: content-type: application/json, revision: 2024-06-15
       Erfolg = 2xx (typisch 202, leerer Body bei Double-Opt-in-Listen). */
  var NEWSLETTER_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var NEWSLETTER_LIST_ID = 'TGJabV';

  // Zentrale Referenz auf das (einmalig erzeugte) Overlay-Element.
  var overlayEl = null;

  // Fallback-Text, wenn Farbe ODER Groesse nicht ermittelbar ist.
  var BIS_FALLBACK_PRODUCT = 'dein gew&uuml;nschtes Produkt';

  // Feedback-Texte (rechtlich/tonal abgestimmt).
  var BIS_MSG_SUCCESS = 'Perfekt! Wir benachrichtigen dich per E-Mail, sobald es wieder verf\u00fcgbar ist.';
  var BIS_MSG_INVALID_EMAIL = 'Bitte gib eine g\u00fcltige E-Mail-Adresse ein.';
  var BIS_MSG_ERROR = 'Etwas ist schiefgelaufen. Bitte versuche es sp\u00e4ter noch einmal.';

  // Button-Beschriftungen waehrend der Zustaende.
  var BIS_BTN_DEFAULT = 'Benachrichtigung erhalten';
  var BIS_BTN_SENDING = 'Wird gesendet\u2026';
  var BIS_BTN_DONE = '\u2713 Eingetragen';

  /* ------------------------------------------------------------------------
     Kleiner HTML-Escaper fuer eingesetzte Variantenwerte (Farbe/Groesse).
     ------------------------------------------------------------------------ */
  function mameidoEscapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ------------------------------------------------------------------------
     Einfache, bewusst tolerante E-Mail-Pruefung (nicht leer, ein @, ein Punkt
     danach, keine Leerzeichen). Bewusst nicht ueber-streng -- die eigentliche
     Validierung macht Klaviyo serverseitig.
     ------------------------------------------------------------------------ */
  function mameidoIsValidEmail(value) {
    if (!value) return false;
    var v = String(value).trim();
    if (v.length < 5) return false;
    if (/\s/.test(v)) return false;
    return /^[^@]+@[^@]+\.[^@]+$/.test(v);
  }

  /* ------------------------------------------------------------------------
     Baut den Body-Text aus der aktuell gewaehlten Variante.
     Farbe = variant.option1, Groesse = variant.option2. Beide vorhanden ->
     beide fett; sonst generischer Fallback.
     ------------------------------------------------------------------------ */
  function mameidoBuildBodyText(variant) {
    var intro = 'Wir holen Nachschub. Lass dich informieren, sobald ';
    var outro = ' wieder auf Lager ist.';

    var color = variant ? variant.option1 : null;
    var size = variant ? variant.option2 : null;

    console.log('[mameido BIS] Variantendaten - option1 (Farbe):', color, '| option2 (Groesse):', size);

    if (color && size) {
      var colorHtml = '<strong>' + mameidoEscapeHtml(color) + '</strong>';
      var sizeHtml = '<strong>' + mameidoEscapeHtml(size) + '</strong>';
      return intro + colorHtml + ' in ' + sizeHtml + outro;
    }
    return intro + '<strong>' + BIS_FALLBACK_PRODUCT + '</strong>' + outro;
  }

  /* ------------------------------------------------------------------------
     Feedback-Zeile setzen. state: 'success' | 'error' | '' (leer = ausblenden).
     ------------------------------------------------------------------------ */
  function mameidoSetFeedback(overlay, message, state) {
    var fb = overlay.querySelector('[data-mameido-bis-feedback]');
    if (!fb) return;
    fb.textContent = message || '';
    if (state) {
      fb.setAttribute('data-state', state);
    } else {
      fb.removeAttribute('data-state');
    }
  }

  /* ------------------------------------------------------------------------
     Button-Zustand setzen: 'default' | 'sending' | 'done'.
     sending/done deaktivieren den Button (verhindert Doppel-Absenden).
     ------------------------------------------------------------------------ */
  function mameidoSetSubmitState(overlay, state) {
    var btn = overlay.querySelector('[data-mameido-bis-submit]');
    if (!btn) return;
    if (state === 'sending') {
      btn.textContent = BIS_BTN_SENDING;
      btn.setAttribute('disabled', '');
    } else if (state === 'done') {
      btn.textContent = BIS_BTN_DONE;
      btn.setAttribute('disabled', '');
    } else {
      btn.textContent = BIS_BTN_DEFAULT;
      btn.removeAttribute('disabled');
    }
  }

  /* ------------------------------------------------------------------------
     Der eigentliche Klaviyo-Client-Call. Baut die Payload gemaess offizieller
     Doku, sendet per fetch, wertet NUR den HTTP-Status aus (202 = Erfolg,
     Body ist leer). Rueckgabe: Promise, das bei Erfolg resolved und bei
     Fehler rejected.
     ------------------------------------------------------------------------ */
  function mameidoSendBisSubscription(email, shopifyVariantId) {
    var url = BIS_ENDPOINT + '?company_id=' + encodeURIComponent(MAMEIDO_BIS_COMPANY_ID);

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: BIS_VARIANT_PREFIX + shopifyVariantId
            }
          }
        }
      }
    };

    console.log('[mameido BIS] Sende Subscription - Variant:', BIS_VARIANT_PREFIX + shopifyVariantId, '| E-Mail:', email);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': BIS_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      // Erfolg = 2xx (typisch 202, leerer Body). KEIN .json() erzwingen.
      if (response.status >= 200 && response.status < 300) {
        console.log('[mameido BIS] Erfolg - HTTP', response.status);
        return true;
      }
      // Fehlerfall: Status ausgeben, ggf. Fehlertext lesen (best effort).
      console.warn('[mameido BIS] Fehlerhafter Status:', response.status);
      return response.text().then(function (txt) {
        console.warn('[mameido BIS] Fehler-Body:', txt);
        throw new Error('HTTP ' + response.status);
      });
    });
  }

  /* ------------------------------------------------------------------------
     OPTIONALE Newsletter-Anmeldung (Stufe 2). Wird NUR aufgerufen, wenn der
     Nutzer das Haekchen gesetzt hat. Traegt die E-Mail in die Liste
     "Homepage_10%" (TGJabV) ein. Die Liste steht auf Double Opt-in -> Klaviyo
     verschickt automatisch die Bestaetigungsmail; erst nach Klick wird der
     Kunde echter Abonnent und der bestehende 10%-Code-Flow loest aus.

     WICHTIG (bewusste Entkopplung): Diese Funktion wirft NIEMALS einen Fehler
     nach aussen. Ein fehlgeschlagener Newsletter-Call darf die BIS-Erfolgs-
     meldung nicht stoeren -- der Kunde hat mit der BIS-Anmeldung bekommen,
     was er wollte. Fehler landen ausschliesslich in der Konsole.
     Erfolg = 2xx (typisch 202, leerer Body). KEIN .json() erzwingen.
     ------------------------------------------------------------------------ */
  function mameidoSendNewsletterSubscription(email) {
    var url = NEWSLETTER_ENDPOINT + '?company_id=' + encodeURIComponent(MAMEIDO_BIS_COMPANY_ID);

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: NEWSLETTER_LIST_ID
            }
          }
        }
      }
    };

    console.log('[mameido BIS] Newsletter-Anmeldung (Haekchen gesetzt) - Liste:', NEWSLETTER_LIST_ID, '| E-Mail:', email);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': BIS_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.status >= 200 && response.status < 300) {
        console.log('[mameido BIS] Newsletter-Anmeldung erfolgreich - HTTP', response.status, '(Double Opt-in-Mail folgt)');
      } else {
        console.warn('[mameido BIS] Newsletter-Anmeldung - unerwarteter Status:', response.status);
      }
    }).catch(function (err) {
      // Bewusst nur loggen -- BIS-Erfolg bleibt unberuehrt.
      console.warn('[mameido BIS] Newsletter-Anmeldung fehlgeschlagen (BIS bleibt unberuehrt):', err);
    });
  }

  /* ------------------------------------------------------------------------
     Modal-Markup einmalig erzeugen und ans <body> haengen. Idempotent.
     Struktur + Klassen exakt passend zum live vorhandenen CSS (.mameido-bis-*).
     ------------------------------------------------------------------------ */
  function mameidoBuildBisModal() {
    if (overlayEl) return overlayEl;

    var existing = document.querySelector('.mameido-bis-overlay');
    if (existing) {
      overlayEl = existing;
      return overlayEl;
    }

    var overlay = document.createElement('div');
    overlay.className = 'mameido-bis-overlay';
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'mameido-bis-headline');

    overlay.innerHTML =
      '<div class="mameido-bis-modal">' +
        '<button type="button" class="mameido-bis-close" data-mameido-bis-close aria-label="Schliessen">' +
          '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<h2 class="mameido-bis-headline" id="mameido-bis-headline">Gerade nicht verf&uuml;gbar<br>&ndash; aber bald wieder!</h2>' +
        '<p class="mameido-bis-body" data-mameido-bis-body></p>' +
        '<input type="email" class="mameido-bis-field" data-mameido-bis-email placeholder="E-Mail-Adresse" autocomplete="email" inputmode="email" />' +
        '<label class="mameido-bis-consent">' +
          '<input type="checkbox" data-mameido-bis-consent />' +
          '<span class="mameido-bis-consent-text">Ja, ich m&ouml;chte Werbung von MAMEIDO per E-Mail erhalten: Newsletter, Angebote und Bewertungsanfragen. 10% auf den Erstkauf inklusive. Abmeldung jederzeit m&ouml;glich.</span>' +
        '</label>' +
        '<button type="button" class="btn btn--full mameido-bis-submit" data-mameido-bis-submit>' + BIS_BTN_DEFAULT + '</button>' +
        '<div class="mameido-bis-feedback" data-mameido-bis-feedback></div>' +
        '<p class="mameido-bis-footer">Wir verwenden deine E-Mail nur f&uuml;r diese Benachrichtigung. Mehr in unserer <a href="/pages/privacy">Datenschutzerkl&auml;rung</a>.</p>' +
      '</div>';

    document.body.appendChild(overlay);
    overlayEl = overlay;

    // --- Schliess-Interaktionen ---
    var closeBtn = overlay.querySelector('[data-mameido-bis-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        mameidoCloseBisModal();
      });
    }
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        mameidoCloseBisModal();
      }
    });

    // --- Absenden: echter Klaviyo-Call ---
    var submitBtn = overlay.querySelector('[data-mameido-bis-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        mameidoHandleSubmit(overlay);
      });
    }

    // Enter im E-Mail-Feld = Absenden ausloesen.
    var field = overlay.querySelector('[data-mameido-bis-email]');
    if (field) {
      field.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          mameidoHandleSubmit(overlay);
        }
      });
    }

    return overlay;
  }

  /* ------------------------------------------------------------------------
     Absenden-Handler: validiert E-Mail + Variant-ID, sendet den Call, steuert
     Button-Zustand und Feedback.
     ------------------------------------------------------------------------ */
  function mameidoHandleSubmit(overlay) {
    var field = overlay.querySelector('[data-mameido-bis-email]');
    var email = field ? String(field.value).trim() : '';
    var variantId = overlay.getAttribute('data-mameido-bis-variant') || '';

    // 1) E-Mail pruefen.
    if (!mameidoIsValidEmail(email)) {
      mameidoSetFeedback(overlay, BIS_MSG_INVALID_EMAIL, 'error');
      if (field) {
        try { field.focus(); } catch (e) {}
      }
      return;
    }

    // 2) Variant-ID vorhanden? (Sollte durch das Oeffnen immer gesetzt sein.)
    if (!variantId) {
      console.warn('[mameido BIS] Keine Variant-ID am Overlay - Abbruch.');
      mameidoSetFeedback(overlay, BIS_MSG_ERROR, 'error');
      return;
    }

    // 3) Senden. Waehrenddessen Button sperren, alte Meldung raeumen.
    mameidoSetFeedback(overlay, '', '');
    mameidoSetSubmitState(overlay, 'sending');

    mameidoSendBisSubscription(email, variantId).then(function () {
      // Erfolg: gruene Meldung, Feld ausblenden, Button auf "done".
      mameidoSetFeedback(overlay, BIS_MSG_SUCCESS, 'success');
      mameidoSetSubmitState(overlay, 'done');
      if (field) {
        field.setAttribute('hidden', '');
      }

      // Stufe 2: Nur bei gesetztem Haekchen zusaetzlich zur Newsletter-Liste
      // anmelden. Voellig unabhaengig -- stoert die BIS-Erfolgsmeldung nie.
      var consent = overlay.querySelector('[data-mameido-bis-consent]');
      if (consent && consent.checked && email) {
        mameidoSendNewsletterSubscription(email);
      }
    }).catch(function (err) {
      // Fehler: rote Meldung, Button reaktivieren -> erneuter Versuch moeglich.
      console.warn('[mameido BIS] Subscription fehlgeschlagen:', err);
      mameidoSetFeedback(overlay, BIS_MSG_ERROR, 'error');
      mameidoSetSubmitState(overlay, 'default');
    });
  }

  /* ------------------------------------------------------------------------
     Modal oeffnen. Setzt Variant-ID + Body-Text frisch, macht sichtbar,
     setzt Fokus, raeumt alten Zustand (Feld sichtbar, Button default,
     Feedback leer) auf.
     ------------------------------------------------------------------------ */
  function mameidoOpenBisModal(variantId) {
    var overlay = mameidoBuildBisModal();

    var variant = (window.mameido && window.mameido.variant) ? window.mameido.variant : null;

    if (variantId) {
      overlay.setAttribute('data-mameido-bis-variant', String(variantId));
    } else {
      overlay.removeAttribute('data-mameido-bis-variant');
    }

    var body = overlay.querySelector('[data-mameido-bis-body]');
    if (body) body.innerHTML = mameidoBuildBodyText(variant);

    // Frischer Start: Feld sichtbar + leer, Consent aus, Button default, Feedback leer.
    var field = overlay.querySelector('[data-mameido-bis-email]');
    if (field) {
      field.removeAttribute('hidden');
      field.value = '';
    }
    var consent = overlay.querySelector('[data-mameido-bis-consent]');
    if (consent) consent.checked = false;
    mameidoSetSubmitState(overlay, 'default');
    mameidoSetFeedback(overlay, '', '');

    overlay.removeAttribute('hidden');
    overlay.setAttribute('data-mameido-bis-open', '');

    setTimeout(function () {
      if (field) {
        try { field.focus(); } catch (e) {}
      }
    }, 0);

    console.log('[mameido BIS] Modal geoeffnet - Variant-ID:', variantId || '(keine)');
  }

  /* ------------------------------------------------------------------------
     Modal schliessen. Versteckt das Overlay und raeumt Feld/Feedback auf.
     ------------------------------------------------------------------------ */
  function mameidoCloseBisModal() {
    if (!overlayEl) return;

    overlayEl.removeAttribute('data-mameido-bis-open');
    overlayEl.setAttribute('hidden', '');

    var field = overlayEl.querySelector('[data-mameido-bis-email]');
    if (field) {
      field.removeAttribute('hidden');
      field.value = '';
    }
    mameidoSetFeedback(overlayEl, '', '');
    mameidoSetSubmitState(overlayEl, 'default');

    console.log('[mameido BIS] Modal geschlossen');
  }

  /* ------------------------------------------------------------------------
     Aktuelle Variant-ID ermitteln (Primaerquelle: window.mameido.variant.id).
     ------------------------------------------------------------------------ */
  function mameidoCurrentVariantId() {
    if (window.mameido && window.mameido.variant && window.mameido.variant.id) {
      return window.mameido.variant.id;
    }
    return null;
  }

  /* ------------------------------------------------------------------------
     Delegierte Verdrahtung: Klick auf [data-mameido-notify] oeffnet das Modal;
     Escape schliesst. Delegation am document -> Quick-View-sicher.
     ------------------------------------------------------------------------ */
  function mameidoInitBisTriggers() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-mameido-notify]') : null;
      if (!btn) return;
      event.preventDefault();
      var variantId = mameidoCurrentVariantId();
      mameidoOpenBisModal(variantId);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (overlayEl && overlayEl.hasAttribute('data-mameido-bis-open')) {
        mameidoCloseBisModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mameidoInitBisTriggers);
  } else {
    mameidoInitBisTriggers();
  }

  // Fuer Debugging/Erweiterung von aussen erreichbar.
  window.mameidoBis = {
    open: mameidoOpenBisModal,
    close: mameidoCloseBisModal,
    build: mameidoBuildBisModal,
    currentVariantId: mameidoCurrentVariantId,
    buildBodyText: mameidoBuildBodyText,
    send: mameidoSendBisSubscription,
    sendNewsletter: mameidoSendNewsletterSubscription,
    companyId: MAMEIDO_BIS_COMPANY_ID
  };
})();
